/**
 * Z-index for all free trial modals.
 * This ensures free trial modals appear above other UI elements like feature release tours.
 */
export const FREE_TRIAL_MODAL_Z_INDEX = 1000;
